
  import cloudinaryRuntime$IPt49Odz_8RwIJLCp5Oo4sMLQ1BFIOiRUi74ipFK6Fo from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/cloudinary'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1440
  },
  "presets": {},
  "provider": "cloudinary",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"cloudinary"} */
    provider: "cloudinary",
    providers: {
        ['cloudinary']: { setup: cloudinaryRuntime$IPt49Odz_8RwIJLCp5Oo4sMLQ1BFIOiRUi74ipFK6Fo, defaults: {"baseURL":"https://cldn.cdn-blackroll.com/image/upload/"} }
    }
  }
